export function getLocations(value) {
  return value.map(location => ({ id: location._id, text: location.name }))
}
